// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"forgotPassword__gradient-bg5__N_3LI","section":"forgotPassword__section__xnDK8"};